import "@hotwired/turbo-rails"
import "./controllers/index.js"
import TC from "@rolemodel/turbo-confirm"

TC.start()
